var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalloweenGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,33.8l-3-1.7l-1-6.4l-0.9-3.5l8.1-1.1V32L42.5,33.8z M41.1,31.1l1.5,0.8l1.6-0.9v-7.9l-4.4,0.6l0.4,1.8 L41.1,31.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 28.3,
    cy: 46.6,
    rx: 10.9,
    ry: 16.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.3,63.8c-6.5,0-11.8-7.7-11.8-17.2s5.3-17.2,11.8-17.2s11.8,7.7,11.8,17.2S34.8,63.8,28.3,63.8z  M28.3,31.3c-5.5,0-9.9,6.9-9.9,15.3c0,8.5,4.5,15.3,9.9,15.3c5.5,0,9.9-6.9,9.9-15.3C38.3,38.2,33.8,31.3,28.3,31.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 33.8,
    cy: 47,
    rx: 12.1,
    ry: 15.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,63.8c-7.2,0-13-7.5-13-16.8s5.8-16.8,13-16.8s13,7.5,13,16.8S41,63.8,33.8,63.8z M33.8,32.1 c-6.1,0-11.1,6.7-11.1,14.9s5,14.9,11.1,14.9S45,55.2,45,47S40,32.1,33.8,32.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 56.7,
    cy: 46.6,
    rx: 10.9,
    ry: 16.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.7,63.8c-6.5,0-11.8-7.7-11.8-17.2s5.3-17.2,11.8-17.2s11.8,7.7,11.8,17.2C68.4,56.1,63.2,63.8,56.7,63.8z  M56.7,31.3c-5.5,0-9.9,6.9-9.9,15.3c0,8.5,4.5,15.3,9.9,15.3s9.9-6.9,9.9-15.3C66.6,38.2,62.1,31.3,56.7,31.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 51.2,
    cy: 47,
    rx: 12.1,
    ry: 15.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.2,63.8c-7.2,0-13-7.5-13-16.8s5.8-16.8,13-16.8s13,7.5,13,16.8S58.3,63.8,51.2,63.8z M51.2,32.1 C45,32.1,40,38.8,40,47s5,14.9,11.1,14.9S62.3,55.2,62.3,47S57.3,32.1,51.2,32.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 42.8,
    cy: 47,
    rx: 10.7,
    ry: 15.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.8,63.8c-6.4,0-11.7-7.5-11.7-16.8s5.2-16.8,11.7-16.8c6.4,0,11.7,7.5,11.7,16.8S49.2,63.8,42.8,63.8z  M42.8,32.1c-5.4,0-9.8,6.7-9.8,14.9s4.4,14.9,9.8,14.9s9.8-6.7,9.8-14.9S48.2,32.1,42.8,32.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalloweenGrey);
export default __webpack_public_path__ + "static/media/HalloweenGrey.9e27d3e496c0691dcd2be942bddcf09c.svg";
export { ForwardRef as ReactComponent };